"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireWildcard(require("react"));

var _FormGroup = _interopRequireDefault(require("./FormGroup.js"));

require("styled-components");

require("prop-types");

require("classnames");

require("./layout.js");

require("./chunk-b15f6972.js");

require("./chunk-6104512b.js");

require("./chunk-76875e58.js");

require("./chunk-cb015231.js");

require("./chunk-f2932d1d.js");

require("./chunk-eb19ede6.js");

require("./chunk-8219403d.js");

require("./chunk-48de8464.js");

require("./chunk-e8276423.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TextInputGroup = function (_PureComponent) {
  (0, _chunkB2edacfb.f)(TextInputGroup, _PureComponent);

  function TextInputGroup() {
    (0, _chunkB2edacfb.b)(this, TextInputGroup);
    return (0, _chunkB2edacfb.d)(this, (0, _chunkB2edacfb.e)(TextInputGroup).apply(this, arguments));
  }

  (0, _chunkB2edacfb.c)(TextInputGroup, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_FormGroup.default, this.props);
    }
  }]);
  return TextInputGroup;
}(_react.PureComponent);

(0, _chunkB2edacfb.h)(TextInputGroup, "displayName", "CTextInput.Group");
(0, _chunkB2edacfb.h)(TextInputGroup, "propTypes", _FormGroup.default.propTypes);
(0, _chunkB2edacfb.h)(TextInputGroup, "defaultProps", _FormGroup.default.defaultProps);
TextInputGroup.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CTextInput.Group",
  "composes": ["../Forms/FormGroup"]
};
var _default = TextInputGroup;
exports.default = _default;